import React from 'react';
import { Modal, Button, Banner } from '@morressier/alembic';
import { Flex, Text } from '@chakra-ui/react';

interface ReviewersInfoWarningModalProps {
  isOpen: boolean;
  infoMessages: Record<string, string>;
  warningMessages: Record<string, string>;
  onCancel: () => void;
  onContinue: () => void;
}

const ReviewersInfoWarningModal: React.FC<ReviewersInfoWarningModalProps> = ({
  isOpen,
  infoMessages,
  warningMessages,
  onCancel,
  onContinue
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      width="600px"
      closeButtonProps={{ hidden: true }}
    >
      <Flex flexDirection="column" gap={4} p={6}>
        <Text textStyle="headingGroup">Warnings & Info</Text>

        <Flex flexDirection="column" gap={2}>
          {Object.entries(warningMessages).map(([email, msg]) => (
            <Banner
              key={email}
              variant="attention"
              heading={email}
              content={msg}
            />
          ))}
        </Flex>

        <Flex flexDirection="column" gap={2}>
          {Object.entries(infoMessages).map(([email, msg]) => (
            <Banner
              key={email}
              variant="neutral"
              heading={email}
              content={msg}
            />
          ))}
        </Flex>

        <Flex justifyContent="flex-end" gap={2} mt={4}>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>

          <Button variant="primary" onClick={onContinue}>
            Continue & Invite Reviewers
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ReviewersInfoWarningModal;
